<template>
    <div class="entradas_salidas">
        <h2 class="subheading grey--text">{{$t('entradas_salidas')}}</h2>
        <v-container>
            <!--    Diálogo Persistente para mostrar Errores en Accesos    -->
            <v-dialog
                    v-model="dialog_errores"
                    persistent
                    width="400"
            >
                <v-card class="justify-center">
                    <v-card-title
                            :class="head_color"
                            primary-title
                    >
                        {{$t('aviso')}}
                    </v-card-title>
                    <v-card-text>
                        <h3 class="text-xs-center"> {{errores_guard}}</h3>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-center">
                        <v-btn
                                v-if="band_gafete"
                                color="primary"
                                x-small
                                :loading="loading_gafete"
                                @click="download_gafete"
                        >{{$t('print_name_tag')}}
                        </v-btn>
                        <v-btn
                                color="primary"
                                @click="dialog_errores = false, errores_guard = '', activar_camara = true, band_gafete = false"
                        >
                            {{$t('aceptar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Diálogo modal Persistente para seleccionar la Caseta -->
            <v-dialog v-model="dialog_inicio" persistent max-width="400px">
                <v-form @submit.prevent="set_caseta()">
                    <v-card class="justify-center">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('selecciona_caseta')}}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-autocomplete
                                    v-model="caseta"
                                    name="caseta"
                                    :items="casetas"
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    :label="$t('Casetas')"
                                    :loading="loading"
                            ></v-autocomplete>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn
                                color="primary"
                                type="submit"
                            >{{ $t('aceptar') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog v-model="dialog" persistent scrollable max-width="500">
                <v-card v-if="entrada" color="blue-grey lighten-4" class="elevation-5 center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog = false, activar_camara = true">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '0'">
                        <v-flex class="text-xs-center" xs12>
                            <h3 class="caption grey--text mb-2">Avatar</h3>
                            <v-img
                                :src="info_invitation.guest_Avatar || info_invitation.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; max-height: 300px;"
                            ></v-img>
                        </v-flex>
                        <br>
                        <v-flex class="text-xs-center" xs12>
                            <table id="datas">
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Visitante')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.guestFirstName}}
                                            {{ info_invitation.guestLastName}}
                                        </h2>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Empresa')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.empresa}}
                                        </h2>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-card-text>
                    <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '1'">
                        <v-flex class="text-xs-center" xs12>
                            <h3 class="caption grey--text mb-2">Avatar</h3>
                            <v-img
                                :src="info_invitation.guest.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; max-height: 300px;"
                            ></v-img>
                        </v-flex>
                        <br>
                        <v-flex class="text-xs-center" xs12>
                            <table id="datas">
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Visitante')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.guest.first_name}}
                                            {{ info_invitation.guest.last_name}}
                                        </h2>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Parque')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.invitation.park_name}}
                                        </h2>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-card-text>
                    <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '2'">
                        <v-flex class="text-xs-center" xs12>
                            <h3 class="caption grey--text mb-2">Avatar</h3>
                            <v-img
                                :src="info_invitation.guest_Avatar || info_invitation.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; max-height: 300px;"
                            ></v-img>
                        </v-flex>
                        <br>
                        <v-flex class="text-xs-center" xs12>
                            <table id="datas">
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Visitante')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.guest_first_name }}
                                            {{ info_invitation.guest_last_name }}
                                        </h2>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <h2>
                                            Empresa origen:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.company_name }}
                                        </h2>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                large
                                color="error"
                                @click="dialog = false, activar_camara = true"
                        >{{this.$t('cerrar')}}
                        </v-btn>
                        <v-btn
                                large
                                color="success"
                                @click="dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                        >{{$t('acceso')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-card v-if="salida" color="blue-grey lighten-4" class="elevation-5 center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog = false, activar_camara = true">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '0'">
                        <v-flex class="text-xs-center" xs12>
                            <h3 class="caption grey--text mb-2">Avatar</h3>
                            <v-img
                                :src="(info_invitation.user && info_invitation.user.avatar) || info_invitation.guest_Avatar || info_invitation.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; max-height: 300px;"
                            ></v-img>
                        </v-flex>
                        <br>
                        <v-flex class="text-xs-center" xs12>
                            <table id="datas">
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Visitante')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.guestFirstName}}
                                            {{ info_invitation.guestLastName}}
                                        </h2>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Empresa')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.empresa}}
                                        </h2>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-card-text>
                    <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '1'">
                        <v-flex class="text-xs-center" xs12>
                            <h3 class="caption grey--text mb-2">Avatar</h3>
                            <v-img
                                :src="info_invitation.guest.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; max-height: 300px;"
                            ></v-img>
                        </v-flex>
                        <br>
                        <v-flex class="text-xs-center" xs12>
                            <table id="datas">
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Visitante')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.guest.first_name}}
                                            {{ info_invitation.guest.last_name}}
                                        </h2>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Parque')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.invitation.park_name}}
                                        </h2>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-card-text>
                    <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '2'">
                        <v-flex class="text-xs-center" xs12>
                            <h3 class="caption grey--text mb-2">Avatar</h3>
                            <v-img
                                :src="(info_invitation.user && info_invitation.user.avatar) || info_invitation.guest_Avatar || info_invitation.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; max-height: 300px;"
                            ></v-img>
                        </v-flex>
                        <br>
                        <v-flex class="text-xs-center" xs12>
                            <table id="datas">
                                <tr>
                                    <th>
                                        <h2>
                                            {{$t('Visitante')}}:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.guest_first_name }}
                                            {{ info_invitation.guest_last_name }}
                                        </h2>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <h2>
                                            Empresa origen:
                                        </h2>
                                    </th>
                                    <td>
                                        <h2>
                                            {{ info_invitation.company_name }}
                                        </h2>
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                large
                                color="error"
                                @click="dialog = false, activar_camara = true"
                        >{{ $t('cerrar')}}
                        </v-btn>
                        <v-btn
                                large
                                color="success"
                                @click="dialog = false, activar_camara = true"
                        >{{$t('registrar_salida')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout class="text-xs-center">
                <v-flex align="center">
                    <v-card class="elevation-5">
                        <v-toolbar class="mb-1" dark color="primary">
                            <v-toolbar-title>
                                {{$t('entradas_salidas')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon dark v-on="on">
                                        <v-icon>settings</v-icon>
                                    </v-btn>
                                </template>
                                <v-card class="configuracion-menu">
                                    <v-card-text class="pa-4">
                                        <label class="config-label">Configuración de Cámaras:</label>
                                        <v-radio-group
                                            v-model="numCuadrantes"
                                            class="mt-3"
                                        >
                                            <v-radio
                                                :value="2"
                                                label="2 Cuadrantes"
                                                class="radio-option"
                                            ></v-radio>
                                            <v-radio
                                                :value="4"
                                                label="4 Cuadrantes"
                                                class="radio-option"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-card-text>
                                </v-card>
                            </v-menu>
                        </v-toolbar>

                        <v-card-text>
                            <h3>{{$t('mensaje_acercar_QR')}}</h3>
                            <v-spacer></v-spacer>

                            <!-- Contenedor de Cámara Única con Grid Visual -->
                            <div class="camera-container-main" :class="`camera-${numCuadrantes}-cuadrantes`">
                                <div class="camera-label"> {{ numCuadrantes === 2 ? '2 Feeds' : '4 Feeds' }}</div>

                                <!-- Canvas Oculto para Procesamiento -->
                                <canvas
                                    ref="detectionCanvas"
                                    style="display: none;"
                                ></canvas>

                                <qrcode-stream
                                    v-if="activar_camara"
                                    @decode="onDecode"
                                    @init="onInit"
                                    class="camera-stream-main"
                                />
                                <p v-if="error" class="error">{{ error }}</p>

                                <!-- Grid Visual de Cuadrantes -->
                                <div
                                    class="cuadrantes-overlay"
                                    :class="`cuadrantes-${numCuadrantes}`"
                                    @click="toggleGridOverlay"
                                >
                                    <div
                                        v-for="(cuadrante, index) in numCuadrantes"
                                        :key="index"
                                        class="cuadrante"
                                        :class="{ 'cuadrante-activo': cuadranteDetectado === index }"
                                    >
                                        <span class="cuadrante-label">{{ index + 1 }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Info de Detección -->
                            <div v-if="cuadranteDetectado !== null" class="deteccion-info">
                                <v-icon small color="green">check_circle</v-icon>
                                <span class="ml-2">QR detectado</span>
                            </div>

                            <v-spacer></v-spacer>
                            <v-divider class="my-3"></v-divider>

                            <!-- Entrada Manual de QR -->
                            <v-layout class="justify-center">
                                <v-form @submit.prevent="get_invitation_manual()">
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="a_qr_code"
                                                autofocus
                                                prepend-icon="select_all"
                                                name="a_qr_code"
                                                :label="$t('qr_code')"
                                                :placeholder="$t('msg_qr_code')"
                                        >
                                        </v-text-field>
                                        <v-btn
                                                color="primary"
                                                large
                                                type="submit">{{$t('enviar')}}
                                        </v-btn>
                                    </v-flex>
                                </v-form>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    import store from '@/store'
    import { mapState, mapGetters } from 'vuex'
    import jsPDF from 'jspdf'

    export default {
        name: "check_in_out",
        components: {
            QrcodeStream
        },
        data () {
            return {
                qr_code: '',
                error: '',
                info_invitation: [],
                dialog: false,
                valido: false,
                id_vigilante: 0,
                salida: false,
                entrada: false,
                estado: '',
                motivo_no_firma: '',
                comentarios_VE: '',
                errores: [],
                datos_coche: '',
                equipo_por_invitacion: [],
                data_access: [],
                dialog_inicio: false,
                casetas: [],
                caseta: 0,
                activar_camara: true,
                loading_gafete: false,
                a_qr_code: '',
                dialog_errores: false,
                errores_guard: '',
                head_color: '',
                band_gafete: false,
                loading: false,
                // Configuración de cuadrantes (1 sola cámara con Splitcam)
                numCuadrantes: 4,
                cuadranteDetectado: null,
                mostrarGridOverlay: true,
                qrYaProcesado: false,
                ultimoQRTiempo: 0,
                // Dispositivos del parque industrial
                industrial_park_devices: [],
                loading_devices: false,
                // Timer para cerrar modal automáticamente
                modal_timer: null
            }
        },
        created: function(){
            this.get_casetas()
            this.get_industrial_park_devices()
            if(localStorage.getItem('id_caseta') === null){
                this.dialog_inicio = true
            }
        },
        watch: {
            numCuadrantes: function() {
                // Reset al cambiar número de cuadrantes
                this.cuadranteDetectado = null
                this.qrYaProcesado = false
                this.mostrarGridOverlay = true
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['caseta_vigilante'])
        },
        methods: {
            onDecode (result) {
                // Evitar procesamiento múltiple rápido
                const ahora = Date.now()
                if (this.qrYaProcesado || (ahora - this.ultimoQRTiempo) < 2000) {
                    return
                }
                
                this.qrYaProcesado = true
                this.ultimoQRTiempo = ahora
                this.qr_code = result
                console.log(`QR detectado: ${result}`)
                
                // Procesar la invitación
                this.get_invitation()
                
                // Reiniciar flag después de procesar
                setTimeout(() => {
                    this.qrYaProcesado = false
                    this.cuadranteDetectado = null
                }, 2000)
            },
            toggleGridOverlay () {
                this.mostrarGridOverlay = !this.mostrarGridOverlay
            },
            get_casetas () {
                this.loading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/GuardHouse/ListCreate/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.casetas = response.data
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            set_caseta () {
                console.log(this.caseta.id)
                console.log(this.caseta.park)
                if(this.caseta.id > 0){
                    localStorage.setItem('id_caseta', this.caseta.id)
                    localStorage.setItem('id_parque', this.caseta.park)
                    this.dialog_inicio = false
                }
            },
            get_industrial_park_devices () {
                this.loading_devices = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Devices/industrial-park-device/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading_devices = false
                        this.industrial_park_devices = response.data
                        console.log('Dispositivos del parque cargados:', this.industrial_park_devices)
                    })
                    .catch(error => {
                        this.loading_devices = false
                        console.log('Error al cargar dispositivos del parque:', error)
                    })
            },
            activate_park_device (deviceLabel) {
                // deviceLabel puede ser 'entrada' o 'salida'
                const id_parque = localStorage.getItem('id_parque')
                
                // Buscar el dispositivo con el label correspondiente (case-insensitive)
                const device = this.industrial_park_devices.find(d => d.label && d.label.toLowerCase() === deviceLabel.toLowerCase())
                
                if (!device) {
                    console.warn(`Dispositivo con label '${deviceLabel}' no encontrado. Dispositivos disponibles:`, this.industrial_park_devices)
                    return
                }
                
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/Devices/industrial-park-device/activate/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        uuid: device.uuid,
                        idParque: id_parque
                    }
                }
                
                axios(config)
                    .then(response => {
                        console.log(`Dispositivo ${deviceLabel} activado exitosamente`, response.data)
                    })
                    .catch(error => {
                        console.log(`Error al activar dispositivo ${deviceLabel}:`, error)
                    })
            },
            onDecode (result) {
                this.qr_code = result
                this.get_invitation()
            },
            get_current_date () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              today = mm + '/' + dd + '/' + yyyy
              return today
            },
            get_invitation () {
                if (this.qr_code !== '') {
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/InvitationPark/all_invitations/' + this.qr_code,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            this.info_invitation = response.data
                            this.valido = true
                            console.log("Valido")
                            this.is_access_in_out_both()
                        })
                        .catch(error => {
                            console.log(error.request.status)
                            if (error.request.status === 404) {
                                this.valido = false
                                console.log("NO Valido")
                                this.clear_without_activate_camera()
                                this.errores_guard = this.$t('mensaje_qr_no_valido')
                                this.head_color = 'red display-1 text--primary justify-center'
                                this.dialog_errores = true
                            }
                            if (error.request.status === 401) {
                                this.valido = false
                                console.log("Invitación No Pertenece al Parque Industrial o Empresa")
                                this.clear_without_activate_camera()
                                this.errores_guard = this.$t('mensaje_qr_no_parque_empresa')
                                this.head_color = 'red display-1 text--primary justify-center'
                                this.dialog_errores = true
                            }
                        })
                }
            },
            get_invitation_manual () {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/all_invitations/' + this.a_qr_code,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.info_invitation = response.data
                        this.valido = true
                        console.log("Valido")
                        this.is_access_in_out_both()
                    })
                    .catch(error => {
                        console.log(error.request.status)
                        if (error.request.status === 404) {
                            this.valido = false
                            console.log("NO Valido")
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_valido')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                        }
                        if (error.request.status === 401) {
                            this.valido = false
                            console.log("Invitación No Pertenece al Parque Industrial o Empresa")
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_parque_empresa')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                        }
                    })

            },
            is_access_in_out_both () {
                if(this.a_qr_code.length > 10)
                    this.qr_code = this.a_qr_code
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationAccessPark/QrCode/' + this.qr_code,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                  .then(response => {
                    console.log(response.data)
                    if (response.data && response.data.user) {
                      this.info_invitation.user = response.data.user
                    }
                    if (this.info_invitation.type === '0') { // Invitación a Empresa dentro del Parque Industrial
                      if (this.info_invitation.typeInv !== 2) { // Invitación Normal
                        if(response.request.status === 204) {
                          console.log("ENTRADA PARK")
                          this.entrada = true
                          this.salida = false
                          this.dialog = true
                          this.activar_camara = false
                          this.create_acceso(true)
                          console.log(this.info_invitation)
                        }
                        if (response.request.status === 200) {
                          if (Object.keys(response.data).length > 0 && response.data.status === 1){
                            this.data_access = response.data
                            this.entrada = false
                            this.salida = true
                            this.dialog = true
                            this.activar_camara = false
                            this.update_acceso(true)
                            console.log('SALIDA PARK')
                          }
                          if (response.data.status === 2){
                            if (response.data.multiple_accesses) {
                              this.entrada = true
                              this.salida = false
                              this.dialog = true
                              this.activar_camara = false
                              this.create_acceso(true)
                            } else {
                              console.log('Invitación Completada')
                              this.clear_without_activate_camera()
                              this.head_color = 'orange display-1 text--primary justify-center'
                              this.errores_guard =this.$t('mensaje_acceso_completo')
                              this.dialog_errores = true
                            }
                          }
                        }
                      } else { // Invitación Recurrente
                        if(response.request.status === 204) {
                          console.log("ENTRADA PARK")
                          this.entrada = true
                          this.salida = false
                          this.dialog = true
                          this.activar_camara = false
                          this.create_acceso(true)
                          console.log(this.info_invitation)
                        } else {
                          if (response.data.status === 1) {
                            this.entrada = false
                            this.salida = true
                            this.dialog = true
                            this.activar_camara = false
                            this.update_acceso(true)
                            console.log('SALIDA RECURRENTE', response.data)
                          } else if (response.data.status === 2) {
                            if (response.data.multiple_accesses) {
                              this.entrada = true
                              this.salida = false
                              this.dialog = true
                              this.activar_camara = false
                              this.create_acceso(true)
                            } else {
                              console.log('COMPLETO RECURRENTE')
                              this.clear_without_activate_camera()
                              this.head_color = 'orange display-1 text--primary'
                              this.errores_guard = this.$t('mensaje_acceso_completo')
                              this.dialog_errores = true
                            }
                          } else {
                            var fechaLocal = new Date(this.get_current_date())
                            const readableDate = response.data.dateTime_EntranceAccess.substring(3, 6) + response.data.dateTime_EntranceAccess.substring(0, 2) + response.data.dateTime_EntranceAccess.substring(5, 10)
                            var fechaAccesoEntrada = new Date(readableDate)
                            // console.log('Fecha de Entrada = ', fechaAccesoEntrada)
                            if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                              this.entrada = true
                              this.salida = false
                              this.dialog = true
                              this.activar_camara = false
                              this.create_acceso(true)
                              console.log('ENTRADA RECURRENTE')
                            } else {
                              console.log('COMPLETO RECURRENTE')
                              this.clear_without_activate_camera()
                              this.head_color = 'orange display-1 text--primary'
                              this.errores_guard = this.$t('mensaje_acceso_completo')
                              this.dialog_errores = true
                            }
                          }
                        }
                      }
                    } else
                    if(this.info_invitation.type === '1') { // Invitación a Parque Industrial
                      if(this.info_invitation.invitation.typeInv !== 2) { // Invitación Normal
                        console.log('Invitación Normal a Parque Industrial')
                        if(response.request.status === 204) {
                          console.log("ENTRADA PARK")
                          this.entrada = true
                          this.salida = false
                          this.dialog = true
                          this.activar_camara = false
                          this.create_acceso(true)
                          console.log(this.info_invitation)
                        }
                        if (response.request.status === 200) {
                          if (Object.keys(response.data).length > 0 && response.data.status === 1){
                            this.data_access = response.data
                            this.entrada = false
                            this.salida = true
                            this.dialog = true
                            this.activar_camara = false
                            this.update_acceso(true)
                            console.log('SALIDA PARK')
                          }
                          if (response.data.status === 2){
                            if (response.data.multiple_accesses) {
                              this.entrada = true
                              this.salida = false
                              this.dialog = true
                              this.activar_camara = false
                              this.create_acceso(true)
                            } else {
                              console.log('Invitación Completada')
                              this.clear_without_activate_camera()
                              this.head_color = 'orange display-1 text--primary justify-center'
                              this.errores_guard =this.$t('mensaje_acceso_completo')
                              this.dialog_errores = true
                            }
                          }
                        }
                      } else { // Invitación Recurrente
                        console.log('Invitación Recurrente a Parque Industrial')
                        if(response.request.status === 204) {
                          console.log("ENTRADA PARK")
                          this.entrada = true
                          this.salida = false
                          this.dialog = true
                          this.activar_camara = false
                          this.create_acceso(true)
                          console.log(this.info_invitation)
                        } else {
                          if (response.data.status === 1) {
                            this.entrada = false
                            this.salida = true
                            this.dialog = true
                            this.activar_camara = false
                            this.update_acceso(true)
                            console.log('SALIDA RECURRENTE', response.data)
                          } else if (response.data.status === 2) {
                            if (response.data.multiple_accesses) {
                              this.entrada = true
                              this.salida = false
                              this.dialog = true
                              this.activar_camara = false
                              this.create_acceso(true)
                            } else {
                              console.log('COMPLETO RECURRENTE')
                              this.clear_without_activate_camera()
                              this.head_color = 'orange display-1 text--primary'
                              this.errores_guard = this.$t('mensaje_acceso_completo')
                              this.dialog_errores = true
                            }
                          } else {
                            var fechaLocal = new Date(this.get_current_date())
                            const readableDate = response.data.dateTime_EntranceAccess.substring(3, 6) + response.data.dateTime_EntranceAccess.substring(0, 2) + response.data.dateTime_EntranceAccess.substring(5, 10)
                            var fechaAccesoEntrada = new Date(readableDate)
                            // console.log('Fecha de Entrada = ', fechaAccesoEntrada)
                            if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                              this.entrada = true
                              this.salida = false
                              this.dialog = true
                              this.activar_camara = false
                              this.create_acceso(true)
                              console.log('ENTRADA RECURRENTE')
                            } else {
                              console.log('COMPLETO RECURRENTE')
                              this.clear_without_activate_camera()
                              this.head_color = 'orange display-1 text--primary'
                              this.errores_guard = this.$t('mensaje_acceso_completo')
                              this.dialog_errores = true
                            }
                          }
                        }
                      }
                                        } else
                                        if(this.info_invitation.type === '2') { // Invitación de Embarque
                                            if(response.request.status === 204) {
                                                this.entrada = true
                                                this.salida = false
                                                this.dialog = true
                                                this.activar_camara = false
                                                this.create_acceso(true)
                                            }
                                            if (response.request.status === 200) {
                                                if (Object.keys(response.data).length > 0 && response.data.status === 1){
                                                    this.data_access = response.data
                                                    this.entrada = false
                                                    this.salida = true
                                                    this.dialog = true
                                                    this.activar_camara = false
                                                    this.update_acceso(true)
                                                }
                                                if (response.data.status === 2){
                                                    if (response.data.multiple_accesses) {
                                                      this.entrada = true
                                                      this.salida = false
                                                      this.dialog = true
                                                      this.activar_camara = false
                                                      this.create_acceso(true)
                                                    } else {
                                                      this.clear_without_activate_camera()
                                                      this.head_color = 'orange display-1 text--primary justify-center'
                                                      this.errores_guard = this.$t('mensaje_acceso_completo')
                                                      this.dialog_errores = true
                                                    }
                                                }
                                            }
                    }
                  })
                  .catch(error => {
                    console.log(error)

                  })
            },
            create_acceso (isAuto = false) {
                console.log(this.qr_code)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/InvitationAccessPark/create/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        guardhouse: localStorage.getItem('id_caseta'),
                        qr_code: this.qr_code
                    }
                }
                axios(config)
                    .then(response => {
                        // Acceso creado exitosamente
                        if (isAuto) {
                            // Acceso automático: activar dispositivo
                            this.activate_park_device('entrada')
                            console.log('Acceso de entrada registrado automáticamente')
                        } else {
                            // Acceso manual: flujo anterior
                            this.clear_without_activate_camera()
                            this.errores_guard = this.$t('mensaje_alta_acceso_in')
                            this.head_color = 'green display-1 text--primary justify-center'
                            this.band_gafete = false
                            this.dialog_errores = true
                        }
                    })
                    .catch(error => {
                        console.log('Error en create_acceso:', error)
                        let errorMessage = this.$t('msg_error')
                        
                        if (error.response) {
                            if (error.response.status === 400) {
                                // Detectar acceso duplicado (Error: "Acceso asociado con este QR está repetido") - tratar como éxito
                                if (error.response.data && error.response.data.Error && error.response.data.Error.includes('repetido')) {
                                    console.log('Acceso ya registrado - tratando como éxito')
                                    this.activate_park_device('entrada')
                                    this.clear_without_activate_camera()
                                    this.errores_guard = this.$t('mensaje_alta_acceso_in')
                                    this.head_color = 'green display-1 text--primary justify-center'
                                    this.dialog_errores = true
                                    return
                                }
                                
                                // Detectar entrada duplicada (código 08) - tratar como éxito
                                if (Array.isArray(error.response.data) && error.response.data[0] && error.response.data[0].code === '08') {
                                    console.log('Entrada ya registrada - tratando como éxito')
                                    this.activate_park_device('entrada')
                                    this.clear_without_activate_camera()
                                    this.errores_guard = this.$t('mensaje_alta_acceso_in')
                                    this.head_color = 'green display-1 text--primary justify-center'
                                    this.dialog_errores = true
                                    return
                                }
                                
                                if (Array.isArray(error.response.data) && error.response.data.length > 1 && error.response.data[1].detail) {
                                    errorMessage = error.response.data[1].detail
                                } else if (error.response.data.detail) {
                                    if (error.response.data.code === '05' && this.info_invitation.type === '2') {
                                        errorMessage = 'Pendiente de autorizacion de supervisor'
                                    } else {
                                        errorMessage = error.response.data.detail
                                    }
                                } else if (typeof error.response.data === 'string') {
                                    errorMessage = error.response.data
                                }
                            }
                        }
                        
                        if (isAuto) {
                            // Error en acceso automático
                            this.dialog = false
                            this.errores_guard = errorMessage
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                        } else {
                            // Error en acceso manual: flujo anterior
                            this.clear_without_activate_camera()
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.errores_guard = errorMessage
                            this.dialog_errores = true
                        }
                    })

            },
            update_acceso (isAuto = false) {
                console.log(this.qr_code)
                let URL = ''
                if (this.info_invitation.type === '0'){
                    URL = 'https://empresa-service.intrare.app/InvitationAccessPark/updateAccessCodePark/' + this.qr_code + '/'
                } else {
                  URL = 'https://empresa-service.intrare.app/InvitationAccessPark/updateAccessInvitationPark/' + this.qr_code + '/'
                }
                const config = {
                    method: 'PATCH',
                    url: URL,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        // Salida actualizada exitosamente
                        if (isAuto) {
                            // Salida automática: activar dispositivo
                            this.activate_park_device('salida')
                            console.log('Salida registrada automáticamente')
                        } else {
                            // Salida manual: flujo anterior
                            this.clear_without_activate_camera()
                            this.head_color = 'green display-1 text--primary justify-center'
                            this.errores_guard = this.$t('mensaje_alta_acceso_out')
                            this.dialog_errores = true
                        }
                    })
                    .catch(error => {
                        console.log('Error en update_acceso:', error)
                        let errorMessage = this.$t('msg_error')
                        
                        if (error.response) {
                            if (error.response.status === 404) {
                                // Detectar salida duplicada (404) - tratar como éxito
                                console.log('Salida ya registrada - tratando como éxito')
                                this.activate_park_device('salida')
                                this.clear_without_activate_camera()
                                this.errores_guard = this.$t('mensaje_alta_acceso_out')
                                this.head_color = 'green display-1 text--primary justify-center'
                                this.dialog_errores = true
                                return
                            }
                            
                            if (error.response.status === 400) {
                                // Detectar acceso duplicado (Error: "Acceso asociado con este QR está repetido") - tratar como éxito
                                if (error.response.data && error.response.data.Error && error.response.data.Error.includes('repetido')) {
                                    console.log('Acceso duplicado - tratando como éxito')
                                    this.activate_park_device('salida')
                                    this.clear_without_activate_camera()
                                    this.errores_guard = this.$t('mensaje_alta_acceso_out')
                                    this.head_color = 'green display-1 text--primary justify-center'
                                    this.dialog_errores = true
                                    return
                                }
                                
                                // Detectar salida duplicada (No encontrado) - tratar como éxito
                                if (error.response.data && error.response.data.detail && error.response.data.detail.includes('No encontrado')) {
                                    console.log('Salida ya registrada - tratando como éxito')
                                    this.activate_park_device('salida')
                                    this.clear_without_activate_camera()
                                    this.errores_guard = this.$t('mensaje_alta_acceso_out')
                                    this.head_color = 'green display-1 text--primary justify-center'
                                    this.dialog_errores = true
                                    return
                                }
                                
                                if (error.response.data.detail) {
                                    errorMessage = error.response.data.detail
                                } else if (typeof error.response.data === 'string') {
                                    errorMessage = error.response.data
                                }
                            }
                        }
                        
                        if (isAuto) {
                            // Error en salida automática
                            this.dialog = false
                            this.errores_guard = errorMessage
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                        } else {
                            // Error en salida manual: flujo anterior
                            if (error.response && error.response.status == 400 && typeof error.response.data == "object" && error.response.data) {
                                this.errores = error.response.data
                            }
                        }
                    })
            },
            notificar_anfitrion_firmar (){
                console.log('Avisar al Anfitrión que firme pase de Salida = ', this.data_access[0].id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPass/' + this.data_access[0].id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async onInit (promise) {
                try {
                    await promise
                    this.error = ''
                } catch (error) {
                    let errorMsg = ''
                    if (error.name === 'NotAllowedError') {
                        errorMsg = "ERROR: necesitas permitir acceso a la cámara"
                    } else if (error.name === 'NotFoundError') {
                        errorMsg = "ERROR: no hay cámara (Splitcam) en este dispositivo"
                    } else if (error.name === 'NotSupportedError') {
                        errorMsg = "ERROR: contexto seguro requerido (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        errorMsg = "ERROR: ¿La cámara ya está en uso?"
                    } else if (error.name === 'OverconstrainedError') {
                        errorMsg = "ERROR: las cámaras no son compatibles"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        errorMsg = "ERROR: Stream API no es soportado en este navegador"
                    } else {
                        errorMsg = `ERROR: ${error.name}`
                    }
                    this.error = errorMsg
                    console.error('Error inicializando cámara:', error)
                }
            },
            clear () {
                this.dialog = false
                this.qr_code = ''
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
                this.activar_camara = true
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            clear_without_activate_camera: function () {
                this.dialog = false
                this.activar_camara = false
                this.qr_code = ''
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
            },
            get_equipo_invitacion: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/equipo_seguridad/' + this.info_invitation[0].id + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        this.equipo_por_invitacion = response.data
                        console.log(this.equipo_por_invitacion)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            xOffset (pdf, text){
                return(
                    pdf.internal.pageSize.width / 2)
                    - (pdf.getStringUnitWidth(text)
                        * pdf.internal.getFontSize() / 2)
            },
            getImgFromUrl(logo_url, callback) {
                var img = new Image();
                img.src = logo_url;
                img.onload = function () {
                    callback(img);
                };
            },
            download_gafete () {
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };

                toDataUrl(this.info_invitation[0].avatar, (myBase64) => {
                    var pdf = new jsPDF("portrait", "pt", "letter")
                    // Black square with rounded corners
                    pdf.setDrawColor(0)
                    pdf.setFillColor(255, 255, 255)
                    pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation[0].empresa,
                        this.xOffset(pdf, this.info_invitation[0].empresa),
                        130)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Visitante'),
                        this.xOffset(pdf, this.$t('Visitante')),
                        145)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation[0].guestFirstName + ' ' + this.info_invitation[0].guestLastName,
                        this.xOffset(pdf, this.info_invitation[0].guestFirstName + ' ' + this.info_invitation[0].guestLastName) ,
                        160)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Anfitrion'),
                        this.xOffset(pdf, this.$t('Anfitrion')),
                        175)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation[0].hostFirstName + ' ' + this.info_invitation[0].hostLastName,
                        this.xOffset(pdf, this.info_invitation[0].hostFirstName + ' ' + this.info_invitation[0].hostLastName),
                        190)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Area'),
                        this.xOffset(pdf, this.$t('Area')),
                        205)
                    pdf.setTextColor(this.info_invitation[0].areaColor)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation[0].areaName.toUpperCase(),
                        this.xOffset(pdf, this.info_invitation[0].areaName.toUpperCase()),
                        220)
                    pdf.setTextColor('#000000')
                    pdf.text(this.$t('fecha_hora'),
                        this.xOffset(pdf, this.$t('fecha_hora')),
                        235)
                    pdf.setFontStyle("normal")
                    pdf.text(this.info_invitation[0].dateInv + ' ' + this.info_invitation[0].timeInv,
                        this.xOffset(pdf, this.info_invitation[0].dateInv + ' ' +  this.info_invitation[0].timeInv),
                        250)
                    pdf.setLineWidth(4.0)
                    pdf.setDrawColor(this.info_invitation[0].areaColor)
                    pdf.setFillColor('#FFFFFF')
                    pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                    // console.log(myBase64); // myBase64 is the base64 string
                    pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                    toDataUrl(this.info_invitation[0].logoEmpresa, (logo_guest) => {
                        pdf.addImage(logo_guest, 'WEBP', 190, 60, 50, 50);
                        this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                            pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50);
                            pdf.save('gafete.pdf')
                        });
                    });
                    this.loading_gafete = false
                });
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
        margin-top: 10px;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }

    /* Configuración de Cuadrantes en Menú */
    .configuracion-menu {
        min-width: 280px;
    }

    .config-label {
        display: block;
        font-weight: 600;
        color: #333;
        margin-bottom: 12px;
        font-size: 14px;
    }

    .radio-option {
        margin-bottom: 8px;
    }

    /* Contenedor Principal de Cámara Splitcam */
    .camera-container-main {
        position: relative;
        width: 100%;
        max-width: 1000px;
        margin: 20px auto;
        border: 3px solid #1976d2;
        border-radius: 8px;
        overflow: hidden;
        background-color: #000;
        aspect-ratio: 16 / 9;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: aspect-ratio 0.3s ease;
    }

    /* Aspect Ratio dinámico según cuadrantes */
    .camera-2-cuadrantes {
        aspect-ratio: 16 / 9;
        max-width: 1000px;
    }

    .camera-4-cuadrantes {
        aspect-ratio: 16 / 9;
        max-width: 1000px;
    }

    .camera-label {
        position: absolute;
        top: 10px;
        left: 10px;
        background-color: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 8px 16px;
        border-radius: 4px;
        font-weight: bold;
        font-size: 14px;
        z-index: 10;
    }

    .camera-stream-main {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    /* Grid Visual de Cuadrantes */
    .cuadrantes-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1px;
        pointer-events: none;
        z-index: 5;
    }

    .cuadrantes-2 {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr;
    }

    .cuadrantes-4 {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
    }

    .cuadrante {
        border: 2px solid rgba(25, 118, 210, 0.3);
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        padding: 8px;
        transition: all 0.3s ease;
    }

    .cuadrante.cuadrante-activo {
        border: 3px solid #4caf50;
        background-color: rgba(76, 175, 80, 0.1);
        box-shadow: inset 0 0 10px rgba(76, 175, 80, 0.3);
    }

    .cuadrante-label {
        background-color: rgba(0, 0, 0, 0.6);
        color: white;
        padding: 4px 8px;
        border-radius: 3px;
        font-weight: bold;
        font-size: 12px;
    }

    .cuadrante.cuadrante-activo .cuadrante-label {
        background-color: #4caf50;
        font-size: 14px;
    }

    /* Info de Detección */
    .deteccion-info {
        text-align: center;
        padding: 12px;
        margin-top: 15px;
        background-color: #e8f5e9;
        border-left: 4px solid #4caf50;
        border-radius: 4px;
        color: #2e7d32;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: slideDown 0.3s ease;
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Responsive */
    @media (max-width: 768px) {
        .camera-container-main {
            max-width: 100%;
        }

        .camera-2-cuadrantes {
            max-width: 100%;
            aspect-ratio: 16 / 9;
        }

        .camera-4-cuadrantes {
            max-width: 100%;
            aspect-ratio: 16 / 9;
        }

        .camera-label {
            font-size: 12px;
            padding: 6px 12px;
        }

        .cuadrante-label {
            font-size: 11px;
        }
    }

    @media (max-width: 480px) {
        .camera-2-cuadrantes {
            aspect-ratio: 16 / 9;
        }

        .camera-4-cuadrantes {
            aspect-ratio: 3 / 2;
        }

        .camera-label {
            font-size: 11px;
            padding: 5px 10px;
        }

        .config-label {
            font-size: 13px;
        }
    }
</style>
